import type { ArticleImageProps } from '@/app/components/ArticleCardsModule';
import type { ArticleCardDataProps } from '@/app/components/ArticleCardsModule/ArticleCard';

export interface WomensHealthPressCardProps {
  articleCards: ArticleCardDataProps[];
  articleImage: ArticleImageProps;
}

const womensHealthPress: WomensHealthPressCardProps = {
  articleCards: [
    {
      heading: 'oura_menstrual_link',
      buttonProps: {
        ariaLabel: 'press_read_article',
        external: true,
        color: 'olive-600',
        href: 'https://ouraring.com/blog/menstrual-cycle-variation/',
        rel: 'noopener noreferrer',
        target: '_blank',
      },
    },
    {
      heading: 'oura_fda_link',
      buttonProps: {
        ariaLabel: 'press_read_article',
        external: true,
        color: 'olive-600',
        href: 'https://ouraring.com/blog/oura-partners-with-fda-cleared-birth-control-app-natural-cycles/',
        rel: 'noopener noreferrer',
        target: '_blank',
      },
    },
    {
      heading: 'oura_prego_link',
      buttonProps: {
        ariaLabel: 'press_read_article',
        external: true,
        color: 'olive-600',
        href: 'https://ouraring.com/blog/sleep-changes-throughout-pregnancy/',
        rel: 'noopener noreferrer',
        target: '_blank',
      },
    },
  ],
  articleImage: {
    alt: 'stretch_hand_img_alt',
    buttonProps: {
      className: 'text-sandstone-500',
      external: true,
      href: 'https://ouraring.com/blog/ouras-commitment-to-prioritizing-womens-health/',
      label: 'read_more',
      rel: 'noopener noreferrer',
      target: '_blank',
      variant: 'secondary-light',
    },
    heading: 'feature_article_title',
    src: 'womens-health/press/hands-stretch',
  },
};

export default womensHealthPress;
